module.exports = __webpack_public_path__ + "4d987364672e74862dc706e60cabc023.jpg";